import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import {
  Phone,
  MapPin,
  Clock,
  Instagram,
  Facebook,
  Menu,
  Award,
  Sparkles,
  Heart,
  Star,
  ChevronRight,
  MessageCircle,
  X,
  Timer,
  Percent } from
"lucide-react";
import { Button } from "./components/ui/button";

// Clinic Info
const CLINIC_INFO = {
  name: "Espelho Feminino",
  tagline: "A Arte de Cuidar de Si",
  description: "Clientes felizes, resultados visíveis. Clínica de estética avançada com 22 anos de experiência dedicados a realçar a sua beleza natural.",
  phone: "927 967 637",
  whatsapp: "351927967637",
  address: "R. Gonçalo Velho N° 56, 8125-221 Quarteira",
  experience: "22",
  instagram: "https://www.instagram.com/espelhofeminino_/",
  facebook: "https://www.facebook.com/espelhofemininobysandra/",
  schedule: [
  { day: "Segunda-feira", hours: "Encerrado" },
  { day: "Terça-feira", hours: "10:00–19:00" },
  { day: "Quarta-feira", hours: "10:00–19:00" },
  { day: "Quinta-feira", hours: "10:00–19:00" },
  { day: "Sexta-feira", hours: "10:00–19:00" },
  { day: "Sábado", hours: "10:00–19:00" },
  { day: "Domingo", hours: "Encerrado" }],

  certifications: [
  "Técnico em Estética Superior",
  "Pós-graduação em Medicina Estética",
  "Cabeleireiro",
  "Micropigmentação",
  "Técnico em Unhas de Gel",
  "Pós-operatório",
  "Redução de Medidas",
  "Rejuvenescimento",
  "Manicure",
  "Depilação Cera & Laser",
  "Tratamento de Celulite",
  "Tratamento Lipedema",
  "Tratamento Linfedema",
  "Tratamento de Fibroses (Pós Lipo)",
  "Terapia Capilar"]

};

// Services
const SERVICES = [
{
  id: 1,
  title: "Limpeza de Pele",
  description: "Limpeza de pele profunda com extração, hidratação e renovação celular para uma pele saudável e radiante.",
  image: "https://customer-assets.emergentagent.com/job_espelho-feminino/artifacts/egs02bob_ChatGPT%20Image%2012_04_2026%2C%2020_53_17.png"
},
{
  id: 2,
  title: "Estética Corporal",
  description: "Procedimentos avançados para modelagem corporal, redução de medidas e tratamento de celulite.",
  image: "https://customer-assets.emergentagent.com/job_espelho-feminino/artifacts/ommsni8u_ESTETICA%20CORPORAL.png"
},
{
  id: 3,
  title: "Tratamento de Fortalecimento Muscular",
  description: "Tecnologia avançada para tonificação e fortalecimento muscular, promovendo contorno corporal definido.",
  image: "https://customer-assets.emergentagent.com/job_espelho-feminino/artifacts/33cfewmw_ChatGPT%20Image%2012_04_2026%2C%2021_13_00.png"
},
{
  id: 4,
  title: "Nails Design",
  description: "Manicure e unhas de gel com acabamento profissional e designs exclusivos para todas as ocasiões.",
  image: "https://customer-assets.emergentagent.com/job_espelho-feminino/artifacts/2icy6zto_ChatGPT%20Image%2012_04_2026%2C%2020_59_42.png"
},
{
  id: 5,
  title: "Cabeleireiro",
  description: "Cortes, coloração, tratamentos capilares e penteados para realçar a sua beleza natural.",
  image: "https://customer-assets.emergentagent.com/job_espelho-feminino/artifacts/7by1p51z_CABELELEIRA.png"
},
{
  id: 6,
  title: "Pós-operatório",
  description: "Drenagem linfática e cuidados especializados para recuperação pós-cirúrgica com resultados seguros.",
  image: "https://customer-assets.emergentagent.com/job_espelho-feminino/artifacts/iupsl8d2_POS%20OPERATORIO.png"
},
{
  id: 7,
  title: "Redução de Medidas",
  description: "Tratamentos corporais avançados para redução de medidas, eliminação de gordura localizada e modelagem.",
  image: "https://customer-assets.emergentagent.com/job_espelho-feminino/artifacts/wso607z3_ChatGPT%20Image%2012_04_2026%2C%2021_16_11.png"
},
{
  id: 8,
  title: "Tratamento de Celulite",
  description: "Protocolos avançados com tecnologia de ponta para combate à celulite e melhoria da textura da pele.",
  image: "https://customer-assets.emergentagent.com/job_espelho-feminino/artifacts/eqtvards_TRATAMENTO%20ANTI%20CELULITICO.webp"
},
{
  id: 9,
  title: "Depilação Cera & Laser",
  description: "Depilação definitiva a laser e depilação com cera quente para uma pele lisa e suave.",
  image: "https://customer-assets.emergentagent.com/job_espelho-feminino/artifacts/4h0j8v8y_LAZER.png"
},
{
  id: 10,
  title: "Ultrassom Micro e Macro Focado",
  description: "Tratamento avançado com ultrassom focado para estimular a produção de colágeno e rejuvenescer a pele naturalmente.",
  image: "https://customer-assets.emergentagent.com/job_espelho-feminino/artifacts/rmlsbstf_ULTRASOM%20MIRO%20E%20MACRO%20FOCADO.png"
},
{
  id: 11,
  title: "Radiofrequência Microagulhamento Fracionado",
  description: "Tecnologia de radiofrequência microagulhada para remodelação facial e corporal com resultados visíveis.",
  image: "https://customer-assets.emergentagent.com/job_espelho-feminino/artifacts/vc12zkgz_ChatGPT%20Image%2013_04_2026%2C%2018_15_24.png"
},
{
  id: 12,
  title: "Terapia Capilar com Análises",
  description: "Diagnóstico completo do couro cabeludo com análise profissional e tratamentos personalizados para saúde capilar.",
  image: "https://images.pexels.com/photos/13899821/pexels-photo-13899821.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
},
{
  id: 13,
  title: "Microagulhamento Facial",
  description: "Tratamento de indução de colágeno com microagulhas para renovação da pele, redução de cicatrizes e rejuvenescimento.",
  image: "https://customer-assets.emergentagent.com/job_espelho-feminino/artifacts/d0tz1fcg_ChatGPT%20Image%2012_04_2026%2C%2021_07_11.png"
}];


// Testimonials
const TESTIMONIALS = [
{
  id: 1,
  name: "Maria Silva",
  service: "Micropigmentação",
  rating: 5,
  text: "Resultado incrível! As minhas sobrancelhas ficaram naturais e perfeitas. A Sandra é uma verdadeira artista. Recomendo a 100%!",
  avatar: "MS"
},
{
  id: 2,
  name: "Ana Costa",
  service: "Estética Facial",
  rating: 5,
  text: "Faço tratamentos faciais há 3 anos e a minha pele nunca esteve tão bem. Profissionalismo e carinho em cada sessão.",
  avatar: "AC"
},
{
  id: 3,
  name: "Carla Rodrigues",
  service: "Unhas de Gel",
  rating: 5,
  text: "As melhores unhas de gel que já fiz! Duram semanas perfeitas. O atendimento é sempre excelente.",
  avatar: "CR"
},
{
  id: 4,
  name: "Sofia Martins",
  service: "Pós-operatório",
  rating: 5,
  text: "Fiz drenagem pós-cirúrgica e a recuperação foi muito mais rápida. Mãos de fada e muito conhecimento técnico.",
  avatar: "SM"
},
{
  id: 5,
  name: "Rita Ferreira",
  service: "Depilação Laser",
  rating: 5,
  text: "Depois de várias sessões, estou livre da depilação! Processo indolor e resultados permanentes. Vale cada cêntimo.",
  avatar: "RF"
},
{
  id: 6,
  name: "Joana Almeida",
  service: "Rejuvenescimento",
  rating: 5,
  text: "Os tratamentos de rejuvenescimento transformaram a minha pele. Pareço 10 anos mais nova! Obrigada Espelho Feminino!",
  avatar: "JA"
},
{
  id: 7,
  name: "Beatriz Santos",
  service: "Redução de Medidas",
  rating: 5,
  text: "Perdi 8cm de cintura em poucas sessões! Os resultados são visíveis e duradouros. Ambiente acolhedor e profissional.",
  avatar: "BS"
},
{
  id: 8,
  name: "Patrícia Oliveira",
  service: "Cabeleireiro",
  rating: 5,
  text: "A Sandra percebe exactamente o que quero. Corte, cor e tratamento sempre impecáveis. Já sou cliente há mais de 10 anos!",
  avatar: "PO"
},
{
  id: 9,
  name: "Inês Pereira",
  service: "Estética Corporal",
  rating: 5,
  text: "Tratamento de celulite que realmente funciona! Notei diferença logo nas primeiras sessões. Super recomendo!",
  avatar: "IP"
},
{
  id: 10,
  name: "Teresa Gomes",
  service: "Manicure",
  rating: 5,
  text: "Manicure perfeita sempre! Atenção aos detalhes e produtos de qualidade. O esmalte dura muito mais tempo.",
  avatar: "TG"
},
{
  id: 11,
  name: "Luísa Fernandes",
  service: "Micropigmentação Lábios",
  rating: 5,
  text: "Fiz micropigmentação nos lábios e adorei! Cor natural e duradoura. A Sandra tem um talento incrível.",
  avatar: "LF"
},
{
  id: 12,
  name: "Catarina Nunes",
  service: "Depilação Cera",
  rating: 5,
  text: "Depilação rápida e praticamente indolor. Pele suave por semanas! Ambiente limpo e profissional.",
  avatar: "CN"
}];


// Gallery Images
// Gallery Images - Antes e Depois
const GALLERY_IMAGES = [
{
  id: 2,
  url: "https://customer-assets.emergentagent.com/job_espelho-feminino/artifacts/8gmu0cst_ChatGPT%20Image%2013_04_2026%2C%2016_28_56.png",
  alt: "Antes - Tratamento Facial",
  className: ""
},
{
  id: 4,
  url: "https://customer-assets.emergentagent.com/job_espelho-feminino/artifacts/vesmovj1_ChatGPT%20Image%2013_04_2026%2C%2016_27_46.png",
  alt: "Depois - Tratamento Facial",
  className: ""
},
{
  id: 3,
  url: "https://customer-assets.emergentagent.com/job_espelho-feminino/artifacts/sb3hbre9_WhatsApp%20Image%202026-04-13%20at%2015.53.46.jpeg",
  alt: "Antes e Depois - Redução de Medidas",
  className: ""
},
{
  id: 6,
  url: "https://customer-assets.emergentagent.com/job_espelho-feminino/artifacts/g6rs79hb_2023-11-10.webp",
  alt: "Antes e Depois - Rejuvenescimento Facial",
  className: ""
},
{
  id: 7,
  url: "https://customer-assets.emergentagent.com/job_espelho-feminino/artifacts/mfr3qbic_ChatGPT%20Image%2013_04_2026%2C%2016_47_22.png",
  alt: "Antes e Depois - Tratamento Celulite Pernas",
  className: ""
},
{
  id: 9,
  url: "https://customer-assets.emergentagent.com/job_espelho-feminino/artifacts/151x5wlg_ChatGPT%20Image%2013_04_2026%2C%2016_40_25.png",
  alt: "Antes e Depois - Tratamento Celulite",
  className: ""
},
{
  id: 10,
  url: "https://customer-assets.emergentagent.com/job_espelho-feminino/artifacts/pdq0winv_WhatsApp%20Image%202026-04-13%20at%2020.50.00.jpeg",
  alt: "Antes e Depois - Tratamento Braço",
  className: ""
},
{
  id: 11,
  url: "https://customer-assets.emergentagent.com/job_espelho-feminino/artifacts/222kwzw1_WhatsApp%20Image%202026-04-13%20at%2020.51.57.jpeg",
  alt: "Antes e Depois - Tratamento Costas",
  className: ""
},
{
  id: 12,
  url: "https://customer-assets.emergentagent.com/job_espelho-feminino/artifacts/ndxgbud0_WhatsApp%20Image%202026-04-13%20at%2021.00.19%20%281%29.jpeg",
  alt: "Antes - Redução de Medidas Corporal",
  className: ""
},
{
  id: 13,
  url: "https://customer-assets.emergentagent.com/job_espelho-feminino/artifacts/uf3jwc0o_WhatsApp%20Image%202026-04-13%20at%2021.00.19.jpeg",
  alt: "Depois - Redução de Medidas Corporal",
  className: ""
}];


// WhatsApp direct link (no predefined message)
const openWhatsApp = () => {
  window.open(`https://wa.me/${CLINIC_INFO.whatsapp}`, "_blank");
};

// Header Component
const Header = ({ isScrolled }) => {
  return (
    <>
      <header
        data-testid="header"
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? "header-glass shadow-sm" : "bg-transparent"}`
        }>

        <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16 sm:h-20">
            {/* Logo */}
            <a href="#inicio" data-testid="logo" className="flex items-center gap-2">
              <span className="font-light text-2xl sm:text-3xl md:text-5xl" style={{ fontFamily: "'Cormorant Garamond', serif", color: "#800020" }}>
                Espelho <span className="font-semibold">Feminino</span>
              </span>
            </a>

            {/* WhatsApp Button - Opens WhatsApp directly */}
            <Button
              data-testid="header-agendar-btn"
              onClick={openWhatsApp}
              className="btn-whatsapp text-xs sm:text-sm px-3 sm:px-4 py-2">

              <MessageCircle className="w-3 h-3 sm:w-4 sm:h-4" />
              <span className="hidden sm:inline">Contactar</span>
            </Button>
          </div>
        </div>
      </header>
    </>);

};

// Hero Section
const HeroSection = () => {
  return (
    <section id="inicio" data-testid="hero-section" className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://customer-assets.emergentagent.com/job_espelho-feminino/artifacts/x75wrfju_ChatGPT%20Image%2012_04_2026%2C%2021_49_39.png"
          alt="Clínica de estética"
          className="w-full h-full object-cover object-right sm:object-center"
          style={{ objectPosition: "70% center" }} />

        <div className="hero-overlay absolute inset-0"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 sm:pt-16 pb-24 sm:pb-32 flex items-start min-h-screen">
        <div className="max-w-xl text-left ml-0 lg:ml-8 mt-4">
          <div className="animate-fadeInUp opacity-0" style={{ animationDelay: "0.1s", animationFillMode: "forwards" }}>
            <span className="inline-flex items-center text-xs sm:text-sm font-medium mb-4 sm:mb-6 py-2 px-3 sm:px-4 gap-2 rounded-full" style={{ backgroundColor: "rgba(253, 240, 243, 0.9)", color: "#800020" }}>
              <Sparkles className="w-3 h-3 sm:w-4 sm:h-4" />
              {CLINIC_INFO.experience} Anos de Experiência
            </span>
          </div>

          <h1
            className="animate-fadeInUp text-3xl sm:text-4xl md:text-5xl lg:text-6xl tracking-tight leading-tight font-medium text-left mb-4 sm:mb-6 opacity-0"
            style={{ fontFamily: "'Cormorant Garamond', serif", color: "#ffffff", textShadow: "2px 2px 4px rgba(0,0,0,0.3)", animationDelay: "0.2s", animationFillMode: "forwards" }}>

            {CLINIC_INFO.tagline}
          </h1>

          <p
            className="animate-fadeInUp text-base sm:text-lg md:text-xl text-left mb-6 sm:mb-8 opacity-0"
            style={{ color: "#ffffff", textShadow: "1px 1px 3px rgba(0,0,0,0.3)", animationDelay: "0.3s", animationFillMode: "forwards" }}>

            {CLINIC_INFO.description}
          </p>

          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 animate-fadeInUp opacity-0" style={{ animationDelay: "0.4s", animationFillMode: "forwards" }}>
            <Button
              data-testid="hero-whatsapp-btn"
              onClick={openWhatsApp}
              className="btn-whatsapp text-sm sm:text-base">

              <MessageCircle className="w-4 h-4 sm:w-5 sm:h-5" />
              Fale Connosco
            </Button>
            <a href="#servicos">
              <Button
                data-testid="hero-services-btn"
                className="btn-outline w-full sm:w-auto text-sm sm:text-base">

                Ver Serviços
                <ChevronRight className="w-4 h-4 ml-2" />
              </Button>
            </a>
          </div>
        </div>
      </div>

      {/* Stats */}
      <div className="absolute bottom-0 left-0 right-0 z-10">
        <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8 pb-4 sm:pb-8">
          <div className="grid grid-cols-3 gap-2 sm:gap-4 max-w-xs sm:max-w-md">
            <div className="text-center p-2 sm:p-4 rounded-lg backdrop-blur-sm" style={{ backgroundColor: "rgba(255,255,255,0.8)" }}>
              <p className="text-xl sm:text-3xl font-light" style={{ fontFamily: "'Cormorant Garamond', serif", color: "#800020" }}>22+</p>
              <p className="text-[10px] sm:text-xs mt-1" style={{ color: "#5C4A4F" }}>Anos</p>
            </div>
            <div className="text-center p-2 sm:p-4 rounded-lg backdrop-blur-sm" style={{ backgroundColor: "rgba(255,255,255,0.8)" }}>
              <p className="text-xl sm:text-3xl font-light" style={{ fontFamily: "'Cormorant Garamond', serif", color: "#800020" }}>9+</p>
              <p className="text-[10px] sm:text-xs mt-1" style={{ color: "#5C4A4F" }}>Certificações</p>
            </div>
            <div className="text-center p-2 sm:p-4 rounded-lg backdrop-blur-sm" style={{ backgroundColor: "rgba(255,255,255,0.8)" }}>
              <p className="text-xl sm:text-3xl font-light" style={{ fontFamily: "'Cormorant Garamond', serif", color: "#800020" }}>1000+</p>
              <p className="text-[10px] sm:text-xs mt-1" style={{ color: "#5C4A4F" }}>Clientes</p>
            </div>
          </div>
        </div>
      </div>
    </section>);

};

// Services Section
const ServicesSection = () => {
  const handleWhatsApp = (service) => {
    window.open(`https://wa.me/${CLINIC_INFO.whatsapp}?text=Olá! Gostaria de saber mais sobre ${service}.`, "_blank");
  };

  return (
    <section id="servicos" data-testid="services-section" className="section-padding" style={{ backgroundColor: "#FCFCFC" }}>
      <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-8 sm:mb-16">
          <span className="inline-block px-3 sm:px-4 py-2 rounded-full text-xs sm:text-sm font-medium mb-3 sm:mb-4" style={{ backgroundColor: "#FDF0F3", color: "#800020" }}>
            Nossos Serviços
          </span>
          <h2
            className="text-2xl sm:text-3xl md:text-4xl tracking-tight leading-tight font-normal mb-3 sm:mb-4"
            style={{ fontFamily: "'Cormorant Garamond', serif", color: "#2D1B20" }}>

            Tratamentos Especializados
          </h2>
          <p className="max-w-2xl mx-auto text-sm sm:text-base px-2" style={{ color: "#5C4A4F" }}>
            Oferecemos uma gama completa de serviços de estética avançada, todos realizados com técnicas profissionais e produtos e tecnologias de alta qualidade.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8">
          {SERVICES.map((service, index) =>
          <div
            key={service.id}
            data-testid={`service-card-${service.id}`}
            className="service-card bg-white p-0 border overflow-hidden group"
            style={{
              borderColor: "#F0E1E4",
              animationDelay: `${index * 0.1}s`
            }}>

              <div className="w-full overflow-hidden bg-white">
                <img
                src={service.image}
                alt={service.title}
                className="w-full h-auto object-contain transition-transform duration-500 group-hover:scale-105" />

              </div>
              <div className="p-4 sm:p-6">
                <h3
                className="text-lg sm:text-xl font-normal mb-2 sm:mb-3"
                style={{ fontFamily: "'Cormorant Garamond', serif", color: "#2D1B20" }}>

                  {service.title}
                </h3>
                <p className="text-xs sm:text-sm mb-3 sm:mb-4" style={{ color: "#5C4A4F" }}>
                  {service.description}
                </p>
                <button
                data-testid={`service-btn-${service.id}`}
                onClick={() => handleWhatsApp(service.title)}
                className="inline-flex items-center text-xs sm:text-sm font-medium transition-colors"
                style={{ color: "#800020" }}>

                  Saber mais
                  <ChevronRight className="w-4 h-4 ml-1" />
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>);

};

// About Section
const AboutSection = () => {
  return (
    <section id="sobre" data-testid="about-section" className="section-padding" style={{ backgroundColor: "#FDF0F3" }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Image */}
          <div className="relative">
            <div className="aspect-[4/5] overflow-hidden rounded-sm">
              <img
                src="https://customer-assets.emergentagent.com/job_espelho-feminino/artifacts/a1moqmrc_CAPA%20SITE.png"
                alt="Profissional de estética"
                className="w-full h-full object-cover" />

            </div>
            {/* Experience Badge */}
            <div
              className="absolute -bottom-6 -right-6 bg-white p-6 rounded-sm shadow-xl"
              style={{ borderLeft: "4px solid #800020" }}>

              <p className="text-4xl font-light" style={{ fontFamily: "'Cormorant Garamond', serif", color: "#800020" }}>
                {CLINIC_INFO.experience}+
              </p>
              <p className="text-sm" style={{ color: "#5C4A4F" }}>Anos de Experiência</p>
            </div>
          </div>

          {/* Content */}
          <div>
            <span className="inline-block px-4 py-2 rounded-full text-sm font-medium mb-4" style={{ backgroundColor: "white", color: "#800020" }}>
              Sobre Nós
            </span>
            <h2
              className="text-3xl sm:text-4xl tracking-tight leading-tight font-normal mb-6"
              style={{ fontFamily: "'Cormorant Garamond', serif", color: "#2D1B20" }}>

              Excelência em Estética Avançada
            </h2>
            <p className="mb-6" style={{ color: "#5C4A4F" }}>
              Com mais de duas décadas de dedicação à beleza e bem-estar, o Espelho Feminino tornou-se referência em tratamentos estéticos na região. 
              Nossa missão é realçar a beleza natural de cada cliente, utilizando as técnicas mais avançadas e produtos de primeira linha.
            </p>
            <p className="mb-8" style={{ color: "#5C4A4F" }}>
              Acreditamos que cada pessoa é única e merece um tratamento personalizado. Por isso, investimos constantemente em formação 
              e atualização profissional para oferecer sempre o melhor aos nossos clientes.
            </p>

            {/* Certifications */}
            <div className="mb-8">
              <h3 className="text-lg font-medium mb-4 flex items-center gap-2" style={{ color: "#2D1B20" }}>
                <Award className="w-5 h-5" style={{ color: "#800020" }} />
                Certificações
              </h3>
              <div className="flex flex-wrap gap-3">
                {CLINIC_INFO.certifications.map((cert, index) =>
                <span
                  key={index}
                  data-testid={`certification-${index}`}
                  className="cert-badge">

                    <Star className="w-3 h-3" style={{ color: "#800020" }} />
                    {cert}
                  </span>
                )}
              </div>
            </div>

            {/* Social Links */}
            <div className="flex items-center gap-4">
              <span className="text-sm" style={{ color: "#5C4A4F" }}>Siga-nos:</span>
              <a
                href={CLINIC_INFO.instagram}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="about-instagram-btn"
                className="social-btn social-btn-instagram">

                <Instagram className="w-5 h-5" />
              </a>
              <a
                href={CLINIC_INFO.facebook}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="about-facebook-btn"
                className="social-btn social-btn-facebook">

                <Facebook className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>);

};

// Gallery Section
const GallerySection = () => {
  return (
    <section id="galeria" data-testid="gallery-section" className="section-padding" style={{ backgroundColor: "#FCFCFC" }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-2 rounded-full text-sm font-medium mb-4" style={{ backgroundColor: "#FDF0F3", color: "#800020" }}>
            Galeria
          </span>
          <h2
            className="text-3xl sm:text-4xl tracking-tight leading-tight font-normal mb-4"
            style={{ fontFamily: "'Cormorant Garamond', serif", color: "#2D1B20" }}>

            A Arte em Cada Detalhe
          </h2>
          <p className="max-w-2xl mx-auto" style={{ color: "#5C4A4F" }}>
            Confira alguns dos nossos trabalhos realizados e inspire-se para a sua próxima transformação.
          </p>
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
          {GALLERY_IMAGES.map((image, index) =>
          <div
            key={image.id}
            data-testid={`gallery-item-${image.id}`}
            className="gallery-item rounded-sm overflow-hidden bg-white shadow-sm">

              <img
              src={image.url}
              alt={image.alt}
              className="w-full h-auto object-contain" />

            </div>
          )}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <p className="mb-4" style={{ color: "#5C4A4F" }}>Veja mais trabalhos nas nossas redes sociais</p>
          <div className="flex justify-center gap-4">
            <a
              href={CLINIC_INFO.instagram}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="gallery-instagram-btn"
              className="social-btn social-btn-instagram">

              <Instagram className="w-5 h-5" />
            </a>
            <a
              href={CLINIC_INFO.facebook}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="gallery-facebook-btn"
              className="social-btn social-btn-facebook">

              <Facebook className="w-5 h-5" />
            </a>
          </div>
        </div>
      </div>
    </section>);

};

// Testimonials Section
const TestimonialsSection = () => {
  return (
    <section id="testemunhos" data-testid="testimonials-section" className="section-padding" style={{ backgroundColor: "#FDF0F3" }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-2 rounded-full text-sm font-medium mb-4" style={{ backgroundColor: "white", color: "#800020" }}>
            Testemunhos
          </span>
          <h2
            className="text-3xl sm:text-4xl tracking-tight leading-tight font-normal mb-4"
            style={{ fontFamily: "'Cormorant Garamond', serif", color: "#2D1B20" }}>

            A Opinião de Quem Confia em Nós
          </h2>
          <p className="max-w-2xl mx-auto" style={{ color: "#5C4A4F" }}>
            A satisfação das nossas clientes é a nossa maior recompensa. Veja o que elas têm a dizer.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {TESTIMONIALS.map((testimonial) =>
          <div
            key={testimonial.id}
            data-testid={`testimonial-card-${testimonial.id}`}
            className="bg-white p-6 rounded-sm border transition-all duration-300 hover:shadow-xl hover:shadow-[#800020]/5"
            style={{ borderColor: "#F0E1E4" }}>

              {/* Rating Stars */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) =>
              <Star key={i} className="w-4 h-4 fill-current" style={{ color: "#800020" }} />
              )}
              </div>
              
              {/* Quote */}
              <p className="mb-6 leading-relaxed" style={{ color: "#5C4A4F" }}>
                "{testimonial.text}"
              </p>
              
              {/* Author */}
              <div className="flex items-center gap-3">
                <div
                className="w-12 h-12 rounded-full flex items-center justify-center text-sm font-medium"
                style={{ backgroundColor: "#FDF0F3", color: "#800020" }}>

                  {testimonial.avatar}
                </div>
                <div>
                  <p className="font-medium" style={{ color: "#2D1B20" }}>{testimonial.name}</p>
                  <p className="text-sm" style={{ color: "#8A797E" }}>{testimonial.service}</p>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <p className="mb-4" style={{ color: "#5C4A4F" }}>Junte-se às nossas clientes satisfeitas</p>
          <button
            data-testid="testimonials-whatsapp-btn"
            onClick={() => window.open(`https://wa.me/${CLINIC_INFO.whatsapp}?text=Olá! Vi os testemunhos e gostaria de agendar uma consulta.`, "_blank")}
            className="btn-whatsapp">

            <MessageCircle className="w-5 h-5" />
            Agende a sua Avaliação
          </button>
        </div>
      </div>
    </section>);

};

// Contact Section

// Contact Section
const ContactSection = () => {
  const mapsEmbedUrl = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3181.8977!2d-8.1056!3d37.0747!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1acdf3b8f8f8f8%3A0x0!2sR.%20Gon%C3%A7alo%20Velho%2056%2C%208125-221%20Quarteira!5e0!3m2!1spt-PT!2spt!4v1234567890";

  return (
    <section id="contato" data-testid="contact-section" className="section-padding" style={{ backgroundColor: "#FCFCFC" }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-2 rounded-full text-sm font-medium mb-4" style={{ backgroundColor: "#FDF0F3", color: "#800020" }}>
            Contacto
          </span>
          <h2
            className="text-3xl sm:text-4xl tracking-tight leading-tight font-normal mb-4"
            style={{ fontFamily: "'Cormorant Garamond', serif", color: "#2D1B20" }}>
            Venha Conhecer-nos
          </h2>
          <p className="max-w-2xl mx-auto" style={{ color: "#5C4A4F" }}>
            Estamos à sua espera para proporcionar uma experiência única de cuidado e beleza.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16">
          {/* Contact Info & Map */}
          <div>
            <div className="space-y-6 mb-8">
              <div className="flex items-start gap-4">
                <div className="p-3 rounded-full" style={{ backgroundColor: "#FDF0F3" }}>
                  <MapPin className="w-5 h-5" style={{ color: "#800020" }} />
                </div>
                <div>
                  <h3 className="font-medium mb-1" style={{ color: "#2D1B20" }}>Morada</h3>
                  <p style={{ color: "#5C4A4F" }}>{CLINIC_INFO.address}</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="p-3 rounded-full" style={{ backgroundColor: "#FDF0F3" }}>
                  <Phone className="w-5 h-5" style={{ color: "#800020" }} />
                </div>
                <div>
                  <h3 className="font-medium mb-1" style={{ color: "#2D1B20" }}>Telefone</h3>
                  <p style={{ color: "#5C4A4F" }}>{CLINIC_INFO.phone}</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="p-3 rounded-full" style={{ backgroundColor: "#FDF0F3" }}>
                  <Clock className="w-5 h-5" style={{ color: "#800020" }} />
                </div>
                <div>
                  <h3 className="font-medium mb-2" style={{ color: "#2D1B20" }}>Horário</h3>
                  <div className="grid grid-cols-2 gap-x-4 gap-y-1">
                    {CLINIC_INFO.schedule.map((item, index) =>
                    <div key={index} className="flex justify-between text-sm" style={{ color: "#5C4A4F" }}>
                        <span>{item.day}</span>
                        <span className="font-medium ml-2">{item.hours}</span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Google Maps */}
            <div className="rounded-sm overflow-hidden border" style={{ borderColor: "#F0E1E4" }}>
              <iframe
                data-testid="google-maps-iframe"
                src={mapsEmbedUrl}
                width="100%"
                height="300"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Localização Espelho Feminino">
              </iframe>
            </div>
            
            <a
              href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(CLINIC_INFO.address)}`}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="open-maps-btn"
              className="mt-4 inline-flex items-center gap-2 text-sm font-medium transition-colors hover:opacity-80"
              style={{ color: "#800020" }}>
              <MapPin className="w-4 h-4" />
              Abrir no Google Maps
              <ChevronRight className="w-4 h-4" />
            </a>
          </div>

          {/* WhatsApp CTA Card */}
          <div className="flex items-center justify-center">
            <div className="contact-card p-8 md:p-10 w-full max-w-md rounded-sm text-center" style={{ backgroundColor: "white", border: "1px solid #F0E1E4" }}>
              <div className="w-20 h-20 mx-auto mb-6 rounded-full flex items-center justify-center" style={{ backgroundColor: "#25D366" }}>
                <MessageCircle className="w-10 h-10 text-white" />
              </div>
              <h3
                className="text-2xl font-normal mb-3"
                style={{ fontFamily: "'Cormorant Garamond', serif", color: "#2D1B20" }}>
                Fale Connosco
              </h3>
              <p className="mb-8 text-sm" style={{ color: "#5C4A4F" }}>
                Entre em contacto connosco pelo WhatsApp. Estamos disponíveis para esclarecer dúvidas, agendar avaliações e muito mais.
              </p>
              <Button
                data-testid="contact-whatsapp-btn"
                onClick={openWhatsApp}
                className="btn-whatsapp w-full justify-center py-4 text-base">
                <MessageCircle className="w-5 h-5" />
                Entrar em Contacto
              </Button>
              <p className="mt-4 text-xs" style={{ color: "#8A797E" }}>
                {CLINIC_INFO.phone}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>);
};

// Footer
const Footer = () => {
  return (
    <footer data-testid="footer" className="py-12" style={{ backgroundColor: "#800020" }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <span
              className="text-2xl font-light block mb-4"
              style={{ fontFamily: "'Cormorant Garamond', serif", color: "white" }}>

              Espelho <span className="font-semibold">Feminino</span>
            </span>
            <p className="text-sm" style={{ color: "rgba(255,255,255,0.7)" }}>
              Clínica de estética avançada com 22 anos de experiência dedicados a realçar a sua beleza natural.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-medium mb-4 text-white">Links Rápidos</h4>
            <nav className="space-y-2">
              {["Início", "Serviços", "Galeria", "Testemunhos", "Sobre", "Contato"].map((link) =>
              <a
                key={link}
                href={`#${link.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")}`}
                className="block text-sm transition-colors hover:text-white"
                style={{ color: "rgba(255,255,255,0.7)" }}>

                  {link}
                </a>
              )}
            </nav>
          </div>

          {/* Social */}
          <div>
            <h4 className="font-medium mb-4 text-white">Siga-nos</h4>
            <div className="flex gap-4">
              <a
                href={CLINIC_INFO.instagram}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram-btn"
                className="w-10 h-10 rounded-full flex items-center justify-center transition-all hover:scale-110"
                style={{ backgroundColor: "rgba(255,255,255,0.1)" }}>

                <Instagram className="w-5 h-5 text-white" />
              </a>
              <a
                href={CLINIC_INFO.facebook}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-facebook-btn"
                className="w-10 h-10 rounded-full flex items-center justify-center transition-all hover:scale-110"
                style={{ backgroundColor: "rgba(255,255,255,0.1)" }}>

                <Facebook className="w-5 h-5 text-white" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 border-t" style={{ borderColor: "rgba(255,255,255,0.1)" }}>
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm" style={{ color: "rgba(255,255,255,0.6)" }}>
              © {new Date().getFullYear()} Espelho Feminino. Todos os direitos reservados.
            </p>
            <a
              href="https://www.livroreclamacoes.pt/inicio"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="livro-reclamacoes-btn"
              className="text-sm font-medium transition-colors hover:text-white underline"
              style={{ color: "rgba(255,255,255,0.7)" }}
            >
              Livro de Reclamações Eletrónico
            </a>
            <p className="text-sm" style={{ color: "rgba(255,255,255,0.6)" }}>
              {CLINIC_INFO.address}
            </p>
          </div>
        </div>
      </div>
    </footer>);

};

// Promo Popup Component
const PromoPopup = ({ isOpen, onClose }) => {
  const [timeLeft, setTimeLeft] = useState({ hours: 2, minutes: 0, seconds: 0 });

  useEffect(() => {
    if (!isOpen) return;

    const savedEnd = localStorage.getItem("promoEndTime");
    let endTime;
    if (savedEnd && Number(savedEnd) > Date.now()) {
      endTime = Number(savedEnd);
    } else {
      endTime = Date.now() + 2 * 60 * 60 * 1000;
      localStorage.setItem("promoEndTime", String(endTime));
    }

    const tick = () => {
      const diff = endTime - Date.now();
      if (diff <= 0) {
        setTimeLeft({ hours: 0, minutes: 0, seconds: 0 });
        return;
      }
      setTimeLeft({
        hours: Math.floor(diff / 3600000),
        minutes: Math.floor((diff % 3600000) / 60000),
        seconds: Math.floor((diff % 60000) / 1000),
      });
    };

    tick();
    const interval = setInterval(tick, 1000);
    return () => clearInterval(interval);
  }, [isOpen]);

  const handlePromoWhatsApp = () => {
    window.open(
      `https://wa.me/${CLINIC_INFO.whatsapp}?text=${encodeURIComponent("Quero aproveitar a promoção de estética facial e corporal")}`,
      "_blank"
    );
    onClose();
  };

  if (!isOpen) return null;

  const pad = (n) => String(n).padStart(2, "0");

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" onClick={onClose}>
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm"></div>
      <div
        className="relative w-full max-w-sm overflow-hidden rounded-lg shadow-2xl"
        onClick={(e) => e.stopPropagation()}
        style={{ background: "linear-gradient(135deg, #800020 0%, #5a0016 100%)" }}
      >
        {/* Close */}
        <button
          data-testid="promo-close-btn"
          onClick={onClose}
          className="absolute top-3 right-3 p-1.5 rounded-full transition-colors z-10"
          style={{ backgroundColor: "rgba(255,255,255,0.15)" }}
        >
          <X className="w-4 h-4 text-white" />
        </button>

        {/* Content */}
        <div className="p-6 sm:p-8 text-center">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full mb-5" style={{ backgroundColor: "rgba(255,255,255,0.15)" }}>
            <Percent className="w-4 h-4 text-white" />
            <span className="text-xs font-semibold text-white tracking-wide uppercase">Oferta Especial</span>
          </div>

          {/* Discount */}
          <div className="mb-4">
            <span className="text-6xl font-bold text-white" style={{ fontFamily: "'Cormorant Garamond', serif" }}>10%</span>
            <p className="text-lg font-light text-white mt-1" style={{ fontFamily: "'Cormorant Garamond', serif" }}>de Desconto</p>
          </div>

          {/* Description */}
          <p className="text-sm mb-6" style={{ color: "rgba(255,255,255,0.85)" }}>
            Em qualquer tratamento de <strong className="text-white">estética facial e corporal</strong>
          </p>

          {/* Timer */}
          <div className="flex items-center justify-center gap-1 mb-6">
            <Timer className="w-4 h-4 mr-1" style={{ color: "rgba(255,255,255,0.7)" }} />
            <div className="flex gap-2">
              {[
                { value: pad(timeLeft.hours), label: "Hrs" },
                { value: pad(timeLeft.minutes), label: "Min" },
                { value: pad(timeLeft.seconds), label: "Seg" },
              ].map((item, i) => (
                <div key={i} className="text-center">
                  <div
                    className="w-12 h-12 flex items-center justify-center rounded-md text-xl font-bold text-white"
                    style={{ backgroundColor: "rgba(255,255,255,0.15)" }}
                  >
                    {item.value}
                  </div>
                  <span className="text-[10px] mt-1 block" style={{ color: "rgba(255,255,255,0.6)" }}>{item.label}</span>
                </div>
              ))}
            </div>
          </div>

          {/* CTA */}
          <button
            data-testid="promo-whatsapp-btn"
            onClick={handlePromoWhatsApp}
            className="w-full py-3.5 rounded-lg font-medium text-sm flex items-center justify-center gap-2 transition-all hover:opacity-90"
            style={{ backgroundColor: "#25D366", color: "white" }}
          >
            <MessageCircle className="w-5 h-5" />
            Aproveitar Promoção
          </button>

          <p className="text-[10px] mt-4" style={{ color: "rgba(255,255,255,0.45)" }}>
            Oferta por tempo limitado
          </p>
        </div>
      </div>
    </div>
  );
};

// Floating WhatsApp Button
const FloatingWhatsApp = () => {
  return (
    <button
      data-testid="floating-whatsapp-btn"
      onClick={openWhatsApp}
      className="whatsapp-float w-14 h-14 rounded-full flex items-center justify-center shadow-lg transition-all hover:shadow-xl"
      style={{ backgroundColor: "#25D366" }}
      aria-label="Contactar via WhatsApp">

      <MessageCircle className="w-7 h-7 text-white" />
    </button>);

};

// Home Page
const Home = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isPromoOpen, setIsPromoOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const dismissed = sessionStorage.getItem("promoDismissed");
    if (!dismissed) {
      const timer = setTimeout(() => setIsPromoOpen(true), 2000);
      return () => clearTimeout(timer);
    }
  }, []);

  const closePromo = () => {
    setIsPromoOpen(false);
    sessionStorage.setItem("promoDismissed", "true");
  };

  return (
    <div className="min-h-screen" style={{ backgroundColor: "#FCFCFC" }}>
      <Header isScrolled={isScrolled} />
      <main>
        <HeroSection />
        <ServicesSection />
        <AboutSection />
        <GallerySection />
        <TestimonialsSection />
        <ContactSection />
      </main>
      <Footer />
      <FloatingWhatsApp />
      <PromoPopup isOpen={isPromoOpen} onClose={closePromo} />
    </div>);

};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>);

}

export default App;